import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import { LoginPinPage } from '../pages/LoginPinPage';
import { BolCreatePage } from '../pages/BolCreatePage';
import { ShowBolPage } from '../pages/ShowBolPage';
import { BolCreatedPageSuccess } from '../pages/BolCreatePage/components/SuccessPopup';
import { ProtectedRoute } from './ProtectedRoute';

export const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={LoginPinPage} />
        <ProtectedRoute exact path="/create" component={BolCreatePage} />
        <Route path="/create/success" component={BolCreatedPageSuccess} />
        <Route exact path="/public/ebol/:token" component={ShowBolPage} />
        <Redirect to='/create' />
      </Switch>
    </BrowserRouter>
  );
};

